


































































































import { Component, Prop } from 'vue-property-decorator'
import UstraComponent from '@ustra/nuxt/src/vue/components/ustra-component'

@Component({
  name: 'ErrorPage',
  layout: 'blank',
  pageConfig: {
    title: '에러페이지',
    layoutType: 'type1',
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends UstraComponent {
  // #region variables
  @Prop()
  readonly error

  get hasHistory() {
    return window.history.length > 2
  }
  // #endregion

  // #region hooks
  // #endregion
  // #region methods
  back() {
    this.$ustra.router.back()
  }

  reload() {
    this.$ustra.router.reload()
  }
  // #endregion
  // #region watches
  // #endregion
}
